export default "__VITE_ASSET__QISQueAR__"